import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';

import * as actions from '../actions/parties';

const initialState = fromJS({
  cad: { data: [], state: null },
  cases: { data: [], state: null },
  codes: {
    types: { data: [], state: null },
    agentAuths: { data: [], state: null },
  },
  files: { data: [], state: null },
  parties: { data: [], state: null },
  party: { data: {}, state: null },
  plaintiff: { data: [], state: null },
  impartial: { data: [], state: null },
  appraisers: { data: [], state: null },
});

const partiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_PARTY_TYPES_START: {
      return state.setIn(['codes', 'types', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_AGENT_AUTHS_START: {
      return state.setIn(
        ['codes', 'agentAuths', 'state'],
        fetchingState.FETCHING,
      );
    }
    case actions.FETCH_PARTIES_START: {
      return state.setIn(['parties', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PARTY_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CAD_PARTIES_START: {
      return state.setIn(['cad', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CAD_PARTY_ASSOCIATION_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CAD_PARTY_ASSOCIATION_FILES_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_CAD_PARTY_START: {
      return state.setIn(['cad', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_CAD_PARTY_ASSOCIATION_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_CAD_PARTY_ASSOCIATION_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_CAD_PARTY_ASSOCIATION_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_CAD_PARTY_START: {
      return state.setIn(['cad', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CAD_PARTY_ASSOCIATIONS_START: {
      return state.setIn(['cad', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PLAINTIFF_PARTIES_START: {
      return state.setIn(['plaintiff', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_PLAINTIFF_PARTY_START: {
      return state.setIn(['plaintiff', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_PLAINTIFF_PARTY_START: {
      return state.setIn(['plaintiff', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PLAINTIFF_PARTY_ASSOCIATION_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_PLAINTIFF_PARTY_ASSOCIATION_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_START: {
      return state.setIn(['plaintiff', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PARTY_FILES_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_PARTY_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_PARTY_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_PARTY_CASES_START: {
      return state.setIn(['cases', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_START: {
      return state.setIn(['impartial', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_IMPARTIAL_PARTY_ASSOCIATION_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.INSERT_IMPARTIAL_PARTY_ASSOCIATION_START: {
      return state.setIn(['party', 'state'], fetchingState.FETCHING);
    }
    case actions.DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_START: {
      return state.setIn(['files', 'state'], fetchingState.FETCHING);
    }
    case actions.FETCH_CASE_APPRAISERS_START: {
      return state.setIn(['appraisers', 'state'], fetchingState.FETCHING);
    }

    case actions.FETCH_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.FETCH_IMPARTIAL_PARTY_ASSOCIATION_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.INSERT_IMPARTIAL_PARTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.DELETE_IMPARTIAL_PARTY_ASSOCIATION_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.FETCH_PARTY_TYPES_SUCCESS: {
      return state
        .setIn(['codes', 'types', 'state'], fetchingState.LOADED)
        .setIn(
          ['codes', 'types', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_AGENT_AUTHS_SUCCESS: {
      return state
        .setIn(['codes', 'agentAuths', 'state'], fetchingState.LOADED)
        .setIn(
          ['codes', 'agentAuths', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_PARTIES_SUCCESS: {
      return state
        .setIn(['parties', 'state'], fetchingState.LOADED)
        .setIn(['parties', 'data'], fromJS(_.get(action, 'data.results')));
    }
    case actions.FETCH_PARTY_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_PARTY_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})))
        .setIn(
          ['parties', 'data'],
          fromJS([
            ...state.getIn(['parties', 'data']).toJS(),
            _.get(action, 'data.results[0]', {}),
          ]),
        );
    }
    case actions.UPDATE_PARTY_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})))
        .setIn(
          ['parties', 'data'],
          fromJS(
            state
              .getIn(['parties', 'data'])
              .toJS()
              .map(x =>
                x.partyID === _.get(action, 'data.results[0].partyID')
                  ? action.data.results[0]
                  : x,
              ),
          ),
        );
    }
    case actions.FETCH_CAD_PARTIES_SUCCESS: {
      return state
        .setIn(['cad', 'state'], fetchingState.LOADED)
        .setIn(['cad', 'data'], _.get(action, 'data.results', []));
    }
    case actions.INSERT_CAD_PARTY_SUCCESS: {
      return state
        .setIn(['cad', 'state'], fetchingState.LOADED)
        .setIn(
          ['cad', 'data'],
          fromJS([
            ...state.getIn(['cad', 'data']).toJS(),
            _.get(action, 'data.results[0]'),
          ]),
        );
    }
    case actions.UPDATE_CAD_PARTY_SUCCESS: {
      return state.setIn(['cad', 'state'], fetchingState.LOADED).setIn(
        ['cad', 'data'],
        fromJS(
          state
            .getIn(['cad', 'data'])
            .toJS()
            .map(el =>
              el.partyID === _.get(action, 'data.results[0].partyID')
                ? action.data.results[0]
                : el,
            ),
        ),
      );
    }
    case actions.DELETE_CAD_PARTY_SUCCESS: {
      return state.setIn(['cad', 'state'], fetchingState.LOADED).setIn(
        ['cad', 'data'],
        fromJS(
          state
            .getIn(['cad', 'data'])
            .toJS()
            .filter(
              el => el.partyID !== _.get(action, 'data.results[0].partyID'),
            ),
        ),
      );
    }
    case actions.FETCH_CAD_PARTY_ASSOCIATIONS_SUCCESS: {
      return state
        .setIn(['cad', 'state'], fetchingState.LOADED)
        .setIn(['cad', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_CAD_PARTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.FETCH_CAD_PARTY_ASSOCIATION_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_CAD_PARTY_ASSOCIATION_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.INSERT_CAD_PARTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.DELETE_CAD_PARTY_ASSOCIATION_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.SET_CAD_PARTY_PRIMARY_SUCCESS: {
      return state.setIn(
        ['cad', 'data'],
        fromJS(
          state
            .getIn(['cad', 'data'])
            .toJS()
            .map(x => {
              const newParty = _.get(action, 'data.results[0]', {});
              return {
                ...x,
                isPrimary: x.assocID === newParty.assocID ? 'Yes' : 'No',
              };
            }),
        ),
      );
    }

    case actions.FETCH_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.FETCH_PLAINTIFF_PARTY_ASSOCIATION_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.INSERT_PLAINTIFF_PARTY_ASSOCIATION_SUCCESS: {
      return state
        .setIn(['party', 'state'], fetchingState.LOADED)
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.INSERT_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.DELETE_PLAINTIFF_PARTY_ASSOCIATION_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(
          ['party', 'data'],
          fromJS({
            ...state.getIn(['party', 'data']).toJS(),
            updateDt: _.get(action, 'data.results[0].updateDt', ''),
          }),
        );
    }
    case actions.SET_PLAINTIFF_PARTY_PRIMARY_SUCCESS: {
      return state.setIn(
        ['plaintiff', 'data'],
        fromJS(
          state
            .getIn(['plaintiff', 'data'])
            .toJS()
            .map(x => {
              const newParty = _.get(action, 'data.results[0]', {});
              return {
                ...x,
                isPrimary: x.assocID === newParty.assocID ? 'Yes' : 'No',
              };
            }),
        ),
      );
    }
    case actions.FETCH_PLAINTIFF_PARTIES_SUCCESS: {
      return state
        .setIn(['plaintiff', 'state'], fetchingState.LOADED)
        .setIn(
          ['plaintiff', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.INSERT_PLAINTIFF_PARTY_SUCCESS: {
      return state
        .setIn(['plaintiff', 'state'], fetchingState.LOADED)
        .setIn(
          ['plaintiff', 'data'],
          fromJS([
            ...state.getIn(['plaintiff', 'data']).toJS(),
            _.get(action, 'data.results[0]'),
          ]),
        );
    }
    case actions.UPDATE_PLAINTIFF_PARTY_SUCCESS: {
      return state.setIn(['plaintiff', 'state'], fetchingState.LOADED).setIn(
        ['plaintiff', 'data'],
        fromJS(
          state
            .getIn(['plaintiff', 'data'])
            .toJS()
            .map(el =>
              el.partyID === _.get(action, 'data.results[0].partyID')
                ? action.data.results[0]
                : el,
            ),
        ),
      );
    }
    case actions.DELETE_PLAINTIFF_PARTY_SUCCESS: {
      return state.setIn(['plaintiff', 'state'], fetchingState.LOADED).setIn(
        ['plaintiff', 'data'],
        fromJS(
          state
            .getIn(['plaintiff', 'data'])
            .toJS()
            .filter(
              el => el.partyID !== _.get(action, 'data.results[0].partyID'),
            ),
        ),
      );
    }
    case actions.FETCH_PLAINTIFF_PARTY_ASSOCIATIONS_SUCCESS: {
      return state
        .setIn(['plaintiff', 'state'], fetchingState.LOADED)
        .setIn(
          ['plaintiff', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.FETCH_PARTY_FILES_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.INSERT_PARTY_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.DELETE_PARTY_FILE_SUCCESS: {
      return state
        .setIn(['files', 'state'], fetchingState.LOADED)
        .setIn(['files', 'data'], fromJS(_.get(action, 'data.results', [])))
        .setIn(['party', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.FETCH_PARTY_CASES_SUCCESS: {
      return state
        .setIn(['cases', 'state'], fetchingState.LOADED)
        .setIn(['cases', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.FETCH_IMPARTIAL_PARTY_ASSOCIATIONS_SUCCESS: {
      return state
        .setIn(['impartial', 'state'], fetchingState.LOADED)
        .setIn(
          ['impartial', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.SET_IMPARTIAL_PARTY_PRIMARY_SUCCESS: {
      return state.setIn(
        ['impartial', 'data'],
        fromJS(
          state
            .getIn(['impartial', 'data'])
            .toJS()
            .map(x => {
              const newParty = _.get(action, 'data.results[0]', {});
              return {
                ...x,
                isPrimary: x.assocID === newParty.assocID ? 'Yes' : 'No',
              };
            }),
        ),
      );
    }
    case actions.SET_CURRENT_PARTY: {
      return state.setIn(
        ['party', 'data'],
        fromJS(_.get(action, 'payload', {})),
      );
    }
    case actions.FETCH_CASE_APPRAISERS_SUCCESS: {
      return state
        .setIn(['appraisers', 'state'], fetchingState.LOADED)
        .setIn(
          ['appraisers', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }

    case actions.SET_APPRAISER_PARTY_PRIMARY_SUCCESS: {
      return state.setIn(
        ['appraisers', 'data'],
        fromJS(
          state
            .getIn(['appraisers', 'data'])
            .toJS()
            .map(x => {
              const newParty = _.get(action, 'data.results[0]', {});
              return {
                ...x,
                isPrimary: x.caseAppraiserID === newParty.caseAppraiserID ? newParty.isPrimary : x.isPrimary,
              };
            }),
        ),
      );
    }

    default: {
      return state;
    }
  }
};

export default partiesReducer;
